import { useLocation } from "react-router-dom";
import useAutoLogout from "utils/autoLogout";
import { formatDate } from "utils/date";

const {
  CardHeader,
  CardBody,
  CardFooter,
  Card,
  Col,
  Row,
} = require("reactstrap");

function Confirmation() {
  const location = useLocation();
  useAutoLogout();

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader className="subTitle">
              Cloud Storage Confirmation
            </CardHeader>

            {location.state &&
              location.state.paymentdata &&
              location.state.activation && (
                <CardBody className="activation">
                  <p>
                    Thank you{" "}
                    <span className="bold">
                      {location.state.paymentdata.firstname}{" "}
                    </span>
                    for purchasing{" "}
                    <span className="bold">
                      {location.state.paymentdata.storage
                        ? location.state.paymentdata.storage
                        : location.state.paymentdata.price}{" "}
                      GB{" "}
                    </span>{" "}
                    of Cloud Storage from WOW Cloud Network. Your order has been
                    successfully processed.
                  </p>
                  <p>
                    If you have any questions or need further assistance, feel
                    free to contact our support team at{" "}
                    <span className="bold">contact@wowcloudnetwork.com</span>
                  </p>

                  <p>
                    {" "}
                    Your activation code is:{" "}
                    <span className="bold">
                      {location.state.activation.activationcode}
                    </span>{" "}
                  </p>

                  <p>
                    This activation code expires on{" "}
                    <span className="bold">
                      {formatDate(
                        location.state.activation.datetimeexpire,
                      )}{" "}
                    </span>
                  </p>

                  <p className="bold">
                    Once Activated, this non-renewable cloudspace is only
                    available for 1 year from the date of purchase.
                  </p>
                </CardBody>
              )}

            <CardFooter></CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Confirmation;
